export default __webpack_public_path__ + "static/media/logo_wilczastrefa.49771456.png";